import type { SxProps, Theme } from '@mui/material/styles';

export const disclosureTooltipPopoverBase: SxProps<Theme> = {
  backgroundColor: 'common.white',
  border: '1px solid',
  borderColor: 'neutral.lighter',
  borderRadius: 0,
  boxShadow:
    '0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12)',
  p: 3,
  maxWidth: '340px',
  textAlign: 'left',
  color: 'common.black',
  fontWeight: 'normal',
  lineHeight: 1.8,
  outline: 'none',
  '&[data-popper-placement*="top"]': {
    marginBottom: 2,
  },
  '&[data-popper-placement*="bottom"]': {
    marginTop: 2,
  },
  '&[data-popper-placement*="left"]': {
    marginRight: 2,
  },
  '&[data-popper-placement*="right"]': {
    marginLeft: 2,
  },
};

export const summaryTableRowCdApyDriverTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  lineHeight: {
    xs: 1.6,
    md: 1.1,
  },
  paddingInlineStart: 2,
  paddingInlineEnd: 2,
  paddingBlockStart: '12px',
  paddingBlockEnd: '12px',
};

export const summaryTableHeadingTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  paddingInlineStart: 2,
  paddingInlineEnd: 2,
  paddingBlockStart: '12px',
  paddingBlockEnd: '12px',
  marginTop: 3,
};

export const summaryTableDetailsCellTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  fontSize: { xs: '0.875rem', md: '11px' },
};

export const summaryTableDriverCellTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  fontSize: { xs: '0.875rem', md: '11px' },
  lineHeight: 1.8,
  paddingInlineStart: 2,
  paddingInlineEnd: 2,
  paddingBlockStart: '12px',
  paddingBlockEnd: '12px',
};

export const numericLayoutTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  maxWidth: '265px',
  paddingInlineStart: 2,
  paddingInlineEnd: 2,
  paddingBlockStart: '12px',
  paddingBlockEnd: '12px',
  lineHeight: '14px',
};

export const singleStarLayoutTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  maxWidth: '265px',
  paddingInlineStart: 2,
  paddingInlineEnd: 2,
  paddingBlockStart: '12px',
  paddingBlockEnd: '12px',
  lineHeight: 1,
};

export const productCardDriverTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  lineHeight: {
    xs: 1.57,
    md: 1.2,
  },
  paddingInlineStart: 2,
  paddingInlineEnd: 2,
  paddingBlockStart: '12px',
  paddingBlockEnd: '12px',
};

export const productCardCdApysDriverTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  lineHeight: {
    xs: 1.6,
    md: 1.2,
  },
  paddingInlineStart: 2,
  paddingInlineEnd: 2,
  paddingBlockStart: '12px',
  paddingBlockEnd: '12px',
};

export const advertisingDisclosureTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  overflowWrap: 'break-word',
  maxWidth: {
    xs: '100vw',
    md: 'min(578px, var(--available-width, calc(100vw - 4px)))',
  },
};

export const factCheckedTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  overflowWrap: 'break-word',
  maxWidth: {
    xs: '100vw',
    md: 'min(420px, var(--available-width, calc(100vw - 4px)))',
  },
};

export const cdApyTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  borderColor: 'neutral.light',
  boxShadow: '0 4px 8px rgba(100, 102, 106, 0.15), 0 8px 16px rgba(100, 102, 106, 0.33)',
  width: '275px',
  maxWidth: '275px',
  p: undefined,
  paddingBlock: 2,
  paddingInline: 3,
};

export const roundupHeaderAdvertisingDisclosureTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  overflowWrap: 'break-word',
  paddingInlineStart: 2,
  paddingInlineEnd: 2,
  paddingBlockStart: '12px',
  paddingBlockEnd: '12px',
  lineHeight: '15px',
  maxWidth: {
    xs: '100vw',
    md: 'min(578px, var(--available-width, calc(100vw - 4px)))',
  },
};

export const apyDriverTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  paddingInlineStart: 2,
  paddingInlineEnd: 2,
  paddingBlockStart: '12px',
  paddingBlockEnd: '12px',
  lineHeight: 1.1,
};

export const multiProductBannerHeaderTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  paddingInlineStart: 3,
  paddingInlineEnd: 3,
  paddingBlockStart: '12px',
  paddingBlockEnd: '12px',
  maxWidth: '232px',
  color: 'neutral.darker',
  lineHeight: { xs: 1.6, md: 1.2 },
};

export const multiProductBannerApyDriverTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  maxWidth: '275px',
  paddingInlineStart: 3,
  paddingInlineEnd: 3,
  paddingBlockStart: 2,
  paddingBlockEnd: 2,
  lineHeight: { xs: 1.6, md: 1.2 },
};

export const disclosureTooltipPopoverSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
};

export const cdRatesProductCardRatingTooltipSx: SxProps<Theme> = {
  ...disclosureTooltipPopoverBase,
  fontSize: '0.875rem',
  lineHeight: {
    xs: 1.8,
    md: 1.5,
  },
  overflowWrap: 'break-word',
  paddingInlineStart: 3.5,
  paddingInlineEnd: 3.5,
  paddingBlockStart: '12px',
  paddingBlockEnd: '12px',
};
